exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-image-viewer__wrapper[data-v-063f691c]{position:fixed;min-width:300px;margin-left:-300px;left:50%;top:25%;margin-top:-50px;z-index:1000;background:rgba(48,49,51,.62);border:1px solid #eee;padding:10px;min-height:300px;display:flex;align-items:center;justify-content:center}.el-image-viewer__close[data-v-063f691c]{top:-10px;right:-10px}.el-image-viewer__img[data-v-063f691c]{width:400px;height:auto}.el-image-viewer__canvas[data-v-063f691c]{cursor:move}.el-image-viewer__actions__inner[data-v-063f691c]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-063f691c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packge/imagePrevie.vue
// module id = 8
// module chunks = 0